import { Mark } from '@tiptap/react';

/**
 * Standalone twin of vMarkdown's `NoteEvidenceHighlight` (see the standalone-twin
 * convention in `src/components/tiptap/CLAUDE.md`). A transient, live-only mark that
 * highlights the note text matching an evidence citation. It defines no markdown
 * serialization, so `getMarkdown()` drops it and it never reaches saved markdown.
 *
 * The `.note-evidence-highlight` class is load-bearing: `useApplyNoteEvidence`'s
 * scroll-into-view query and `parseHTML` both key off it.
 */
export const NoteEvidenceHighlight = Mark.create({
  name: 'noteEvidenceHighlight',

  parseHTML() {
    return [
      {
        tag: 'span.note-evidence-highlight',
      },
    ];
  },

  renderHTML() {
    return [
      'span',
      {
        class: 'note-evidence-highlight rounded-sm bg-entity-blue-muted',
        'data-note-evidence': '',
      },
      0,
    ];
  },
});
